export type Bilingual = [english: string, spanish: string];
export type FoodTone = "green" | "marigold" | "cream" | "chili";

export const TACO_ASSEMBLED =
  "https://cdn.magicpatterns.com/uploads/q9uEWJa1J8FFb1Mvjewd9X/Imagen_de_ChatGPT_5_oct_2026,_15_29_51-1.png";

export const TACO_EXPLODED =
  "https://cdn.magicpatterns.com/uploads/mCPJdXY8DqcN66XfVKfP9a/Imagen_de_ChatGPT_5_oct_2026,_15_29_51-2.png";

/** Each phrase owns a slice of the scroll journey (0 → 1). */
export const tacoPhrases: { text: Bilingual; range: [number, number] }[] = [
  { text: ["Handcrafted with flavor.", "Hecho a mano con sabor."], range: [0, 0.28] },
  { text: ["Built with tradition.", "Construido con tradición."], range: [0.28, 0.56] },
  { text: ["Fresh. Bold. Unforgettable.", "Fresco. Intenso. Inolvidable."], range: [0.56, 0.8] },
  { text: ["Made to celebrate.", "Hecho para celebrar."], range: [0.8, 1] },
];

/** Label positions are percentages over the deconstructed taco image. */
export const tacoIngredients: { name: Bilingual; left: string; top: string }[] = [
  { name: ["Handmade tortilla", "Tortilla hecha a mano"], left: "78%", top: "20%" },
  { name: ["Fire-grilled steak", "Carne asada"], left: "22%", top: "44%" },
  { name: ["Fresh cilantro", "Cilantro fresco"], left: "48%", top: "9%" },
  { name: ["White onion", "Cebolla blanca"], left: "17%", top: "29%" },
  { name: ["Grilled pineapple", "Piña asada"], left: "60%", top: "68%" },
  { name: ["Lime", "Limón"], left: "82%", top: "60%" },
];

export const HERO_POSTER =
  "https://cdn.magicpatterns.com/patterns/generated-images/293e45d7-db05-4336-b39c-3dc0df6b787a.jpg";

export const CELEBRATION_IMAGE =
  "https://cdn.magicpatterns.com/uploads/hk2AtY7gmEPMCbeXa2rT2x/Blue_Agave_Mexican_Fiesta_Spread.png";

export const foodMoments: {
  image: string;
  alt: string;
  label: Bilingual;
  phrase: Bilingual;
  detail: Bilingual;
  tone: FoodTone;
}[] = [
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/293e45d7-db05-4336-b39c-3dc0df6b787a.jpg",
    alt: "Al pastor street tacos on handmade corn tortillas with pineapple, onion, cilantro and lime",
    label: ["Street tacos", "Tacos callejeros"],
    phrase: ["Made with tradition.", "Hecho con tradición."],
    detail: [
      "Fire-grilled meats on warm handmade tortillas, finished with onion, cilantro and fresh lime.",
      "Carnes a la parrilla sobre tortillas hechas a mano, con cebolla, cilantro y limón fresco.",
    ],
    tone: "green",
  },
  {
    image: "https://cdn.magicpatterns.com/patterns/generated-images/5bb124da-9a57-4285-886f-afb7bc424473.jpg",
    alt: "Fresh guacamole in a stone molcajete surrounded by Talavera bowls of salsa and tortilla chips",
    label: ["Guacamole & salsas", "Guacamole y salsas"],
    phrase: ["Fresh ingredients. Bold flavor.", "Ingredientes frescos. Sabor intenso."],
    detail: [
      "Ripe avocados, house-made salsas and crisp tortilla chips, prepared fresh every day.",
      "Aguacate maduro, salsas de la casa y totopos crujientes, preparados frescos cada día.",
    ],
    tone: "marigold",
  },
];

export const storySegments: { en: string; es: string; highlight?: boolean }[] = [
  { en: "At Blue Agave, every plate is inspired by the ", es: "En Blue Agave, cada plato está inspirado en los " },
  { en: "flavors, traditions and hospitality of Mexico.", es: "sabores, tradiciones y hospitalidad de México.", highlight: true },
  { en: " From ", es: " Desde " },
  { en: "tacos shared around the table", es: "tacos compartidos alrededor de la mesa", highlight: true },
  {
    en: " to unforgettable celebrations with family and friends, our goal is simple: ",
    es: " hasta celebraciones inolvidables con familia y amigos, nuestro objetivo es simple: ",
  },
  {
    en: "make every visit feel like a fiesta worth remembering.",
    es: "que cada visita se sienta como una fiesta digna de recordar.",
    highlight: true,
  },
];

export const storyPillars: Bilingual[] = [
  ["Flavor", "Sabor"],
  ["Tradition", "Tradición"],
  ["Fiesta", "Fiesta"],
];

export const foodFinale = {
  image: "https://cdn.magicpatterns.com/patterns/generated-images/3267ca27-b13a-44db-b43d-5e859b1493f2.jpg",
  alt: "Hands pressing fresh corn tortillas on a hot comal",
  phrase: ["Every plate tells a story.", "Cada plato cuenta una historia."] as Bilingual,
};

export const celebrationTypes: Bilingual[] = [
  ["Private Events", "Eventos privados"],
  ["Catering", "Catering"],
  ["Weddings", "Bodas"],
  ["Wedding Receptions", "Recepciones"],
  ["Birthday Celebrations", "Cumpleaños"],
  ["Corporate Events", "Eventos corporativos"],
  ["Family Gatherings", "Reuniones familiares"],
  ["Special Occasions", "Ocasiones especiales"],
];

export const marigoldPetals = [
  { left: "6%", size: 10, duration: 14, delay: 0, color: "#E8871E" },
  { left: "18%", size: 7, duration: 18, delay: -6, color: "#F2C230" },
  { left: "31%", size: 9, duration: 16, delay: -11, color: "#E8871E" },
  { left: "47%", size: 6, duration: 20, delay: -3, color: "#F2C230" },
  { left: "62%", size: 10, duration: 15, delay: -9, color: "#E8871E" },
  { left: "74%", size: 7, duration: 19, delay: -14, color: "#C1272D" },
  { left: "86%", size: 9, duration: 17, delay: -5, color: "#E8871E" },
  { left: "94%", size: 6, duration: 21, delay: -16, color: "#F2C230" },
];
